import React from 'react';
import PropTypes from 'prop-types';
// import ReactGA from 'react-ga';
import { withRouter } from 'react-router';
import './Navbar.scss';

export class Navbar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isBurgerOpened: false,
      cssClass: props.location.pathname === '/' ? 'hideMenuBkg' : 'showMenuBkg'
    };
  }

  componentDidMount = () => {
    window.addEventListener('scroll', this.handleScroll);
  };

  componentDidUpdate = prevProps => {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.handleScroll();
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  };

  onMenuItemClickHandler = event => {
    const cssClass = event.currentTarget.name === '/' ? 'hideMenuBkg' : 'showMenuBkg';
    this.props.history.push(event.currentTarget.name);
    this.setState({ isBurgerOpened: false, cssClass });
    window.scrollTo(0, 0);
  };

  onBurgerClickHandler = () => {
    this.setState(prevState => ({ isBurgerOpened: !prevState.isBurgerOpened }));
  };

  // onRegisterClick = () => {
  //   if (document.cookie.replace(/(?:(?:^|.*;\s*)ga_gdpr\s*=\s*([^;]*).*$)|^.*$/, '$1') === 'yes') {
  //     ReactGA.event({
  //       category: 'Button',
  //       action: 'Clicked Register Now button'
  //     });
  //   }
  // };

  handleScroll = () => {
    if (this.props.location.pathname === '/') {
      const scrollY = window.scrollY || window.pageYOffset;
      const percentage = scrollY / window.innerHeight;
      if (percentage > 0.65) {
        return this.setState({ cssClass: 'showMenuBkg' });
      }
      if (percentage < 0.8) {
        return this.setState({ cssClass: 'hideMenuBkg' });
      }
    } else {
      this.setState({ cssClass: 'showMenuBkg' });
    }
  };

  render() {
    const { pathname } = this.props.location;
    const { cssClass, isBurgerOpened } = this.state;

    return (
      <div className="nav-menu">
        <nav className={`navbar is-fixed-top ${cssClass}`}>
          <div className="container">
            <div className="navbar-brand">
              <div className="navbar-start">
                <button
                  className={`navbar-burger burger ${isBurgerOpened ? 'is-active' : ''}`}
                  data-target="navMenu"
                  onClick={this.onBurgerClickHandler}
                  type="button">
                  <i className="fas fa-bars" />
                </button>
              </div>
              <div className="social-buttons">
                {/* <a
                  className="navbar-item"
                  href="https://twitter.com/OpenSlava"
                  rel="noopener noreferrer"
                  target="_blank">
                  <i aria-hidden="true" className="fab fa-twitter" />
                </a> */}
                <a
                  className="navbar-item"
                  href="https://www.facebook.com/OpenSlava"
                  rel="noopener noreferrer"
                  target="_blank">
                  <i aria-hidden="true" className="fab fa-facebook-f" />
                </a>
                <a
                  className="navbar-item"
                  href="https://www.instagram.com/openslava/?hl=en"
                  rel="noopener noreferrer"
                  target="_blank">
                  <i aria-hidden="true" className="fab fa-instagram" />
                </a>
                <a
                  className="navbar-item"
                  href="https://www.linkedin.com/groups/12017066"
                  rel="noopener noreferrer"
                  target="_blank">
                  <i aria-hidden="true" className="fab fa-linkedin-in" />
                </a>
              </div>
            </div>

            <div className={`navbar-menu ${isBurgerOpened ? 'is-active' : ''}`} id="navMenu">
              <div className="navbar-start">
                <button
                  className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/' ? 'menu-item-active' : ''}`}
                  name="/"
                  onClick={this.onMenuItemClickHandler}
                  type="button">
                  {isBurgerOpened ? 'Home' : <i className="fas fa-home" />}
                </button>
                <button
                  className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/program' ? 'menu-item-active' : ''}`}
                  name="/program"
                  onClick={this.onMenuItemClickHandler}
                  type="button">
                  Program
                </button>
                <button
                  className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/workshops' ? 'menu-item-active' : ''}`}
                  name="/workshops"
                  onClick={this.onMenuItemClickHandler}
                  type="button">
                  Hands-on Labs
                </button>
                <button
                  className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/speakers' ? 'menu-item-active' : ''}`}
                  name="/speakers"
                  onClick={this.onMenuItemClickHandler}
                  type="button">
                  Speakers
                </button>
                <button
                  className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}
                                    ${pathname === '/contacts' ? 'menu-item-active' : ''}`}
                  name="/contacts"
                  onClick={this.onMenuItemClickHandler}
                  type="button">
                  Contacts
                </button>
                <a
                  className={`navbar-item ${isBurgerOpened ? 'menu-item' : ''}`}
                  href="https://www.openslava.sk/2019"
                  rel="noopener noreferrer"
                  target="_blank">
                  2019
                </a>
              </div>

              {!isBurgerOpened && (
                <div className="navbar-end">
                  <a
                    className="navbar-item"
                    href="https://twitter.com/OpenSlava"
                    rel="noopener noreferrer"
                    target="_blank">
                    <i aria-hidden="true" className="fab fa-twitter" />
                  </a>
                  <a
                    className="navbar-item"
                    href="https://www.facebook.com/OpenSlava"
                    rel="noopener noreferrer"
                    target="_blank">
                    <i aria-hidden="true" className="fab fa-facebook-f" />
                  </a>
                  <a
                    className="navbar-item"
                    href="https://www.instagram.com/openslava/?hl=en"
                    rel="noopener noreferrer"
                    target="_blank">
                    <i aria-hidden="true" className="fab fa-instagram" />
                  </a>
                  <a
                    className="navbar-item"
                    href="https://www.linkedin.com/groups/12017066"
                    rel="noopener noreferrer"
                    target="_blank">
                    <i aria-hidden="true" className="fab fa-linkedin-in" />
                  </a>
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

Navbar.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string.isRequired }).isRequired
};

export default withRouter(Navbar);
